<template>
  <div class="addProject">
    <h3 class="title">{{title}}</h3>
    <el-form label-width="100px" :model="formData" ref="formData">
      <div class="card">
        <!-- <el-form-item label="诊断" prop="menuName">
          <el-input v-model="formData.menuName" placeholder="请输入诊断名称" @input="testSX" style="width:90%;"></el-input>
        </el-form-item> -->
        <div>
          <div v-for="(domain, idx) in formData.diagnoseList" :key="idx">
            <el-form-item label="诊断">
              <div class="flex">
                <el-input style="width:90%;" v-model="domain.menuName" placeholder="请输入诊断" @input="testSX"></el-input>
                <el-button size="mini" type="danger" @click.prevent="edit(domain,idx)" v-show="idx > 0">
                  <i class="el-icon-delete"></i>
                </el-button>
              </div>
            </el-form-item>
          </div>
          <el-form-item style="text-align: right;margin-right:5%;">
            <el-button @click="add" type="primary" size="mini">新增诊断</el-button>
          </el-form-item>
        </div>
        <div>
          <div v-for="(domain, idx) in formData.operationNameList" :key="idx">
            <el-form-item label="规范手术名称">
              <div class="flex">
                <el-input style="width:90%;" v-model="domain.menuName" placeholder="请输入规范手术名称" @input="testSX"></el-input>
                <el-button size="mini" type="danger" @click.prevent="editRemoveDomain(domain,idx)" v-show="idx > 0">
                  <i class="el-icon-delete"></i>
                </el-button>
              </div>
            </el-form-item>
          </div>
          <el-form-item style="text-align: right;margin-right:5%;">
            <el-button @click="editDomain" type="primary" size="mini">新增手术名称</el-button>
          </el-form-item>
        </div>
        <el-form-item label="登记表">
          <el-radio-group v-model="formData.registrationType" :disabled="disabled">
            <el-radio label="1">外科</el-radio>
            <el-radio label="2">皮肤科</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="footer">
        <el-form-item>
          <el-button type="danger" @click="resetForm('formData')">取 消</el-button>
          <el-button type="primary" @click="doAddgoods('formData')">确 定</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import Store from "../../assets/common.vue";
export default {
  props: ['code', 'formData'],
  data() {
    return {
      title: '',
      disabled: false,
    }
  },
  created() {
    if (this.code == 0) {
      this.title = '新增诊断'
      this.disabled = false
    } else if (this.code == 1) {
      this.title = '编辑诊断'
      this.disabled = true
    }
  },
  methods: {
    testSX() {
      this.$forceUpdate()
    },
    doAddgoods(formData) {
      let createBy = Lockr.get("empId");
      this.formData.createBy = createBy
      //   新增数据
      if (this.code == 0) {
        let arr = this.formData.operationNameList.map((item, index) => {
          return item.menuName;
        });
        let arr1 = this.formData.diagnoseList.map((item, index) => {
          return item.menuName;
        });
        let querys = {
          registrationType: this.formData.registrationType,
          createBy: createBy,
          menuName: arr1.toString(),
          operationName: arr.toString(),
          id: this.formData.id,
        }
        this.$refs[formData].validate((valid) => {
          api.requestQuiet("/register/createDiagnose", querys, (res) => {
            if (res.result == true) {
              _g.toast("success", '新增成功!');
              this.$emit('add-comment')
              this.$emit('closeDialog')
            } else {
              _g.toast("error", '新增失败!');
            }
          }, (err) => {
            this.loading = false
          })
        })
      } else if (this.code == 1) {//修改数据
        this.$refs[formData].validate((valid) => {
          api.requestQuiet("/register/updateDiagnose", this.formData, (res) => {
            if (res.result == true) {
              _g.toast("success", '修改成功!');
              this.$emit('add-comment')
              this.$emit('closeDialog')
            } else {
              _g.toast("error", '修改失败!');
            }
          }, (err) => {
            this.loading = false
          })
        })
      }

    },
    resetForm() {
      this.$emit('closeDialog')
    },
    // 编辑时删除手术名称
    editRemoveDomain(item, listIndex) {
      var index = this.formData.operationNameList.indexOf(item)
      if (index !== -1) {
        this.formData.operationNameList.splice(listIndex, 1)
      }
      this.$forceUpdate()
    },
    // 编辑时新增手术名称
    editDomain() {
      this.formData.operationNameList.push({
        operationName: "",
        key: Date.now()
      });
      this.$forceUpdate()
    },

    // 编辑时删除诊断
    edit(item, listIndex) {
      var index = this.formData.diagnoseList.indexOf(item)
      if (index !== -1) {
        this.formData.diagnoseList.splice(listIndex, 1)
      }
      this.$forceUpdate()
    },
    // 编辑时新增诊断
    add() {
      this.formData.diagnoseList.push({
        menuName: "",
        key: Date.now()
      });
      this.$forceUpdate()
    },
  }
}
</script>
<style scoped>
.footer {
  display: flex;
  justify-content: space-around;
  margin-top: 60px;
}
.sure {
  margin-left: 50px;
}
.title {
  text-align: center;
  margin-bottom: 30px;
}
.addProject >>> .el-form-item__content {
  line-height: 40px !important;
}
.flex {
  display: flex;
  align-items: flex-start;
}
.flex >>> .el-button i {
  margin: 0 !important;
}
.flex >>> .el-button--mini {
  margin: 8px;
}

.footer >>> .el-form-item__content {
  margin-left: 0 !important;
}
</style>